export default "/_nuxt/b155a0f9ee21567ebdce5b5973590ddf.svg";